import { render, staticRenderFns } from "./ExpandableItems.vue?vue&type=template&id=9383fc7c&scoped=true&"
import script from "./ExpandableItems.vue?vue&type=script&lang=js&"
export * from "./ExpandableItems.vue?vue&type=script&lang=js&"
import style0 from "./ExpandableItems.vue?vue&type=style&index=0&id=9383fc7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9383fc7c",
  null
  
)

export default component.exports